import { useImperativeHandle, useMemo, useState } from "react";
import { AgGridReact } from "ag-grid-react";
import { themeAlpine } from "ag-grid-community";
import {
  ClientSideRowModelModule,
  ModuleRegistry,
  RowSelectionModule,
  ValidationModule,
  PaginationModule,
  TextFilterModule,
  NumberFilterModule,
  DateFilterModule,
  CustomFilterModule,
  ColumnAutoSizeModule,
  RowStyleModule,
  CellStyleModule,
  CsvExportModule,
} from "ag-grid-community";
import { Pagination } from "./Pagination";
ModuleRegistry.registerModules([
  RowSelectionModule,
  ClientSideRowModelModule,
  PaginationModule,
  TextFilterModule,
  NumberFilterModule,
  DateFilterModule,
  CustomFilterModule,
  ColumnAutoSizeModule,
  ValidationModule,
  CellStyleModule,
  RowStyleModule,
  CsvExportModule,
]);
export const Table = ({
  columns,
  rowData,
  showPagination = true,
  currentPage,
  pageSize,
  onPaginationChange,
  totalRecords,
  rowSelection,
  autoFit = true,
  gridRef,
  isRowSelectable = () => { },
  ...restTableProps
}) => {
  const containerStyle = useMemo(() => ({ width: "100%", height: "100%" }), []);
  const gridStyle = useMemo(() => ({ height: "100%", width: "100%" }), []);
  const [gridAPi, setGridAPi] = useState(null);

  const rowSelectionType = useMemo(() => {
    return {
      mode: rowSelection || "multiRow",
    };
  }, [rowSelection]);

  useImperativeHandle(gridRef, () => {
    return {
      gridAPi,
    };
  });

  const resizeAndSetAPi = (params) => {
    autoFit && params.api.sizeColumnsToFit();
    setGridAPi(params.api);
  };

  // Case-insensitive comparator
  const caseInsensitiveComparator = (valueA, valueB) => {
    if (valueA == null) return -1;
    if (valueB == null) return 1;
    return valueA.toString().toLowerCase().localeCompare(valueB.toString().toLowerCase());
  };

  return (
    <div style={containerStyle}>
      <div style={gridStyle} className="ag-theme-material">
        <AgGridReact
          {...restTableProps}
          gridOptions={{
            defaultColDef: {
              resizable: true,
              comparator: caseInsensitiveComparator,
            },
            rowSelection: {
              ...rowSelectionType,
              isRowSelectable: isRowSelectable,
              hideDisabledCheckboxes: true,
            },
          }}
          theme={themeAlpine}
          rowData={rowData}
          columnDefs={columns}
          onGridReady={resizeAndSetAPi}
          // onGridSizeChanged={resizeAndSetAPi}
          // onRowDataUpdated={resizeAndSetAPi}
          suppressPaginationPanel={true}
          suppressCellFocus={true}
          rowModelType="clientSide"
        />
        {showPagination && rowData ?.length > 0 && (
          <Pagination
            currentPage={currentPage}
            onPaginationChange={onPaginationChange}
            pageSize={pageSize}
            totalRecords={totalRecords}
          />
        )}
      </div>
    </div>
  );
};
